//
// useOnElementResize
//
// When you need the dimensions of the current element, e.g. to determine the number of
// items that can fit.
//
// Usage:
//
//     const [ref, {width, height}] = useOnElementResize(600,400)
//     return (
//         <View ref={ref}>
//             Width: {width}
//             Height: {height}
//         </View>
//     )

import { useLayoutEffect, useRef, useState } from 'react'

export const useOnElementResize = (initialwidth, initialheight) => {
    const [width, setWidth] = useState(initialwidth)
    const [height, setHeight] = useState(initialheight)
    const ref = useRef(null)

    const resizeobserver = useRef(null)

    useLayoutEffect(() => {
        if (!ref.current) return

        if (resizeobserver.current && ref.current) {
            resizeobserver.current.unobserve(ref.current)
        }

        resizeobserver.current = new ResizeObserver(entries => {
            // window.requestAnimationFrame tries to prevent
            // 'ResizeObserver loop completed with undelivered notifications.'
            window.requestAnimationFrame(() => {
                if (!ref.current) return
                for (let entry of entries) {
                    setWidth(Math.floor(entry.contentRect.width))
                    setHeight(Math.floor(entry.contentRect.height))
                }
            })
        })
        const element = ref.current
        resizeobserver.current.observe(element)

        return () => {
            resizeobserver.current.unobserve(element)
        }
    }, [])

    return [ref, { width, height }]
}
